import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWeatherFewClouds = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 30.919,
	height: 21.605,
	viewBox: "0 0 30.919 21.605",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Group_6632",
		"data-name": "Group 6632",
		transform: "translate(12901 12380.633)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path_9038",
				"data-name": "Path 9038",
				d: "M7.849,8.421,3.164,7.912l.51,4.685L0,15.55,3.674,18.5l-.51,4.685,4.685-.51L10.8,26.353l2.919-3.633c-.037-.025-.074-.05-.11-.078a9.482,9.482,0,0,1-5.731-.031,9.52,9.52,0,0,1-4.14-4.138,9.494,9.494,0,0,1,0-5.845A9.516,9.516,0,0,1,7.88,8.49a9.491,9.491,0,0,1,5.844,0,9.507,9.507,0,0,1,4.135,4.128c.028-.063.059-.126.092-.187l.49-4.519-4.685.509L10.8,4.747Z",
				transform: "translate(-12901 -12385.381)",
				fill: "#f6db00"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_9039",
				"data-name": "Path 9039",
				d: "M18.132,13.64a2.975,2.975,0,0,0-.4-.029,3.008,3.008,0,0,0-2.75,1.743,4.546,4.546,0,0,0-.706-.055c-2.011,0-3.64,1.3-3.64,2.9a3.022,3.022,0,0,0,2.375,2.726,2.727,2.727,0,0,0,2.519,1.808,2.591,2.591,0,0,0,1.627-.581A3.987,3.987,0,0,0,20.94,24.23a4.491,4.491,0,0,0,3.233-1.236,2.56,2.56,0,0,0,1.078.239A2.738,2.738,0,0,0,27.8,21.357a2.523,2.523,0,0,0,.4.035,2.913,2.913,0,0,0,0-5.813,2.584,2.584,0,0,0-1.33.372,2.8,2.8,0,0,0-2.71-2.621,2.614,2.614,0,0,0-.687.1,2.692,2.692,0,0,0-5.338.214",
				transform: "translate(-12901 -12385.381)",
				fill: "#67a4fe"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_9040",
				"data-name": "Path 9040",
				d: "M4.291,15.55a6.513,6.513,0,0,0,8.511,6.2,3.508,3.508,0,0,1-.2-.371A3.515,3.515,0,0,1,10.08,18.2c0-1.907,1.88-3.458,4.193-3.458a3.253,3.253,0,0,1,.394.016,3.543,3.543,0,0,1,2.195-1.594A6.511,6.511,0,0,0,4.291,15.55",
				transform: "translate(-12901 -12385.381)",
				fill: "#f6db00"
			})
		]
	})
});
export { SvgWeatherFewClouds as ReactComponent };
